const trainingStatus = [
  { label: 'Not Started', value: 0 },
  { label: 'In Progress', value: 1 },
  { label: 'Completed', value: 2 },
]

export default trainingStatus
